const sizes = {
  "section-header-desktop": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "56px",
    letterSpacing: "-1.4px",
    lineHeight: "60px",
    m: "0",
    textAlign: "unset",
  },
  "section-header-tablet": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "45px",
    letterSpacing: "-1.4px",
    lineHeight: "47px",
    m: "0",
    textAlign: "unset",
  },
  "section-header-mobile": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "28px",
    letterSpacing: "-0.7px",
    lineHeight: "30px",
    m: "0",
    textAlign: "unset",
  },
  "carousel-header-desktop": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "96px !important",
    letterSpacing: "-2.6px",
    lineHeight: "96px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "carousel-header-tablet": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "77px",
    letterSpacing: "-2.4px",
    lineHeight: "77px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "carousel-header-mobile": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "38px",
    letterSpacing: "-1.2px",
    lineHeight: "42px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "cards-header-xl": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "85px",
    letterSpacing: "-1.7px",
    lineHeight: "85px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "cards-header": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "64px",
    letterSpacing: "-1.7px",
    lineHeight: "64px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "cards-header-tablet": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "56px",
    letterSpacing: "-0.84px",
    lineHeight: "56px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "cards-header-mobile": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "28px",
    letterSpacing: "-0.84px",
    lineHeight: "33px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "portrait-slider-header-desktop": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "40px",
    letterSpacing: "-1px",
    lineHeight: "43px",
    color: "white",
    m: "0",
    textAlign: "unset",
  },
  "portrait-slider-header-tablet": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "32px",
    letterSpacing: "-1px",
    lineHeight: "33px",
    color: "black",
    m: "0",
    textAlign: "unset",
  },
  "portrait-slider-header-mobile": {
    fontFamily: "Libre Franklin, sans-serif", 
    fontWeight: 600,
    fontSize: "20px",
    letterSpacing: "-0.5px",
    lineHeight: "22px",
    color: "black",
    m: "0",
    textAlign: "unset",
  },

  // DLS
  "terra-desktop": {  
    fontSize: "6rem",
    fontWeight: "500",
    lineHeight: "5.875rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "terra-tablet": {  
    fontSize: "5rem",
    fontWeight: "500",
    lineHeight: "4.875rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "terra-mobile": {  
    fontSize: "4rem",
    fontWeight: "500",
    lineHeight: "4.25rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "giga-desktop": {
    fontSize: "4.5rem",
    fontWeight: "500",
    lineHeight: "4.875rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "giga-tablet": {
    fontSize: "3.5rem",
    fontWeight: "500",
    lineHeight: "4rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "giga-mobile": {
    fontSize: "2.25rem",
    fontWeight: "500",
    lineHeight: "2.625rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "mega-desktop": {
    fontSize: "3.5rem",
    fontWeight: "500",
    lineHeight: "3.75rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "mega-tablet": {
    fontSize: "2.875rem",
    fontWeight: "500",
    lineHeight: "3.375rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "mega-mobile": {
    fontSize: "2.275rem",
    fontWeight: "500",
    lineHeight: "2.75rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "big-desktop": {
    fontSize: "3rem",
    fontWeight: "500",
    lineHeight: "3.5rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "big-tablet": {
    fontSize: "2.25rem",
    fontWeight: "500",
    lineHeight: "2.675rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "big-mobile": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "1.875rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "alpha-desktop": {
    fontSize: "2rem",
    fontWeight: "500",
    lineHeight: "2.625rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "alpha-tablet": {
    fontSize: "2rem",
    fontWeight: "500",
    lineHeight: "2.625rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "alpha-mobile": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "1.95rem",
    letterSpacing: "-1px",
    color: "black"
  },
  "bravo-desktop": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "1.95rem",
    color: "black"
  },
  "bravo-tablet": {
    fontSize: "1.5rem",
    fontWeight: "500",
    lineHeight: "1.95rem",
    color: "black"
  },
  "bravo-mobile": {
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.675rem",
    color: "black"
  },
  "charlie-desktop": {
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.675rem",
    color: "black"
  },
  "charlie-tablet": {
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.675rem",
    color: "black"
  },
  "charlie-mobile": {
    fontSize: "1rem",
    fontWeight: "500",
    lineHeight: "1.5rem",
    color: "black"
  },
  "delta-desktop": {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "delta-tablet": {
    fontSize: "1.125rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "delta-mobile": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.25rem",
    color: "black"
  },
  "echo-desktop": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "echo-tablet": {
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.5rem",
    color: "black"
  },
  "echo-mobile": {
    fontSize: "0.75rem",
    fontWeight: "400",
    lineHeight: "1.25rem",
    color: "black"
  },
}

export const Heading = {
    sizes
}
